import React from 'react';

import { pick } from 'ramda';
import { Flex } from 'src/common/components/flex/flex';
import { Text } from 'src/common/components/text/text';
import { XLogo } from 'src/common/components/x-logo/x-logo';

import { FOOTER_LINKS, LEGAL_FOOTER_LINKS } from '../../constants';
import { FooterLink } from '../footer-link';
import { FooterSection } from '../footer-section';
import './footer.css';

export const Footer = () => (
  <footer className="footer-v3">
    <Flex className="footer-v3__container">
      <Flex className="footer-v3__container__column">
        <FooterSection
          sections={Object.values(pick(['company', 'product'], FOOTER_LINKS))}
        />
      </Flex>

      <Flex className="footer-v3__container__column">
        <FooterSection
          sections={Object.values(pick(['tools'], FOOTER_LINKS))}
        />
      </Flex>

      <Flex className="footer-v3__container__column">
        <FooterSection
          sections={Object.values(pick(['support'], FOOTER_LINKS))}
        />

        <FooterSection
          sections={Object.values(pick(['learning'], FOOTER_LINKS))}
        />

        <div>
          <a
            href="https://twitter.com/streamable"
            target="_blank"
            rel="noreferrer"
            className="footer-v3-link"
          >
            <XLogo />
          </a>
        </div>

        <div>
          <Text as="p" className="footer-v3__copyright-text">
            &copy; Bending Spoons Operations S.p.A.
            <br />
            Sole shareholder company subject to the management and coordination
            of Bending Spoons S.p.A.
            <br />
            Via Nino Bonnet 10, 20154, Milan, Italy
            <br />
            VAT, tax code, and number of registration with the Milan Monza
            Brianza Lodi Company Register 13368510965
            <br />
            REA number MI 2718456
            <br />
            Contributed capital &euro;150.000,00 fully paid-in
          </Text>
        </div>
      </Flex>
    </Flex>

    <Flex as="ul" direction="row" className="footer-v3__legal">
      {LEGAL_FOOTER_LINKS.links.map((link) => (
        <li key={`footer-legal-link-${link.label}`}>
          <FooterLink {...link} />
        </li>
      ))}
    </Flex>
  </footer>
);
